import React from "react"
import styled from "@emotion/styled"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

const BannerWrapper = styled.div`
    & img {
        max-width: 100%;
        height: auto;
    }
`

const BannerBackground = styled.div`
    position: relative;
    width: 100%;
    padding-top: 36.5%;
`

const BannerImage = styled.div`
    position: absolute;
    right: 7%;
    color: #fff;
    top: -2rem;
    width: 600px;
    height: 600px;
    & img {
        width: 100%;
    }

    @media screen and (min-width: 1800px) {
        top: 1rem;
    }

    @media screen and (max-width: ${(props) => props.theme.breakpoints[8]}) {
        width: 500px;
    }

    @media screen and (max-width: ${(props) => props.theme.breakpoints[7]}) {
        width: 450px;
    }

    // @media screen and (max-width: ${(props) => props.theme.breakpoints[6]}) {
    //     width: 470px;
    // }

    @media screen and (max-width: ${(props) => props.theme.breakpoints[5]}) {
        width: 400px;
    }

    @media screen and (max-width: ${(props) => props.theme.breakpoints[4]}) {
        right: 5%;
        width: 370px;
    }

    @media screen and (max-width: ${(props) => props.theme.breakpoints[3]}) {
        width: 300px;
        top: 0;
    }

    @media screen and (max-width: ${(props) => props.theme.breakpoints[3]}) {
        width: 250px;
    }

    @media screen and (max-width: ${(props) => props.theme.breakpoints[2]}) {
        width: 200px;
    }

    @media screen and (max-width: ${(props) => props.theme.breakpoints[1]}) {
        width: 150px;
    }
`

const CaptionBox = styled.div`
    position: absolute;
    right: 15%;
    left: 15%;
    z-index: 10;
    color: #fff;
    top: 5rem;
    width: 50%;

    @media screen and (min-width: 1441px) {
        left: 15%;
    }

    @media screen and (max-width: ${(props) => props.theme.breakpoints[8]}) {
        left: 10%;
        top: 0;
    }
    @media screen and (max-width: ${(props) => props.theme.breakpoints[4]}) {
        top: 2rem;
    }
    @media screen and (max-width: ${(props) => props.theme.breakpoints[3]}) {
        top: 0;
    }
    @media screen and (max-width: ${(props) => props.theme.breakpoints[2]}) {
        margin-top: 0;
        left: 10%;
        width: 70%;
    }
    @media screen and (max-width: ${(props) => props.theme.breakpoints[1]}) {
        // top: 0;
    }
`

function topBanner({ data }) {
    const bgObject = {
        backgroundImage: data.banner_background_color,
        backgroundSize: "200.00px 200.00px",
    }

    return (
        <BannerWrapper>
            <BannerBackground style={bgObject} />
            <CaptionBox className="caption-box-topbanner">
                <h3>{data.subtitle}</h3>
                <h1>{data.title}</h1>
            </CaptionBox>
            <BannerImage>
                <GatsbyImage
                    image={getImage(data.imageFile)}
                    alt={data.title}
                />
            </BannerImage>
        </BannerWrapper>
    )
}

export default topBanner
